!function () {

  function t(e) {
    return t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
      ? function (t) { return typeof t }
      : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
            ? "symbol"
            : typeof t
        },
      t(e)
  }

  function e(t, e) {
    return function (t) {
      if (Array.isArray(t)) return t
    }(t) ||
    function (t, e) {
      var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
      if (null != r) {
        var n, o, i, c, a = [], u = !0, l = !1;
        try {
          if (i = (r = r.call(t)).next, 0 === e) {
            if (Object(r) !== r) return;
            u = !1
          } else {
            for (; !(u = (n = i.call(r)).done) && (a.push(n.value), a.length !== e); u = !0);
          }
        } catch (t) {
          l = !0, o = t
        } finally {
          try {
            if (!u && null != r.return && (c = r.return(), Object(c) !== c)) return
          } finally {
            if (l) throw o
          }
        }
        return a
      }
    }(t, e) ||
    function (t, e) {
      if (t) {
        if ("string" == typeof t) return r(t, e);
        var n = {}.toString.call(t).slice(8, -1);
        return "Object" === n && t.constructor && (n = t.constructor.name),
          "Map" === n || "Set" === n ? Array.from(t)
          : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          ? r(t, e)
          : void 0
      }
    }(t, e) ||
    function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.")
    }()
  }

  function r(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = Array(e); r < e; r++) n[r] = t[r];
    return n
  }

  function n(t, e) {
    for (var r = 0; r < e.length; r++) {
      var n = e[r];
      n.enumerable = n.enumerable || !1;
      n.configurable = !0;
      "value" in n && (n.writable = !0);
      Object.defineProperty(t, u(n.key), n)
    }
  }

  function o(t) {
    var e = "function" == typeof Map ? new Map : void 0;
    return o = function (t) {
      if (null === t || !function (t) {
        try {
          return -1 !== Function.toString.call(t).indexOf("[native code]")
        } catch (e) {
          return "function" == typeof t
        }
      }(t)) return t;

      if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

      if (void 0 !== e) {
        if (e.has(t)) return e.get(t);
        e.set(t, r)
      }

      function r() {
        return function (t, e, r) {
          if (i()) return Reflect.construct.apply(null, arguments);
          var n = [null];
          n.push.apply(n, e);
          var o = new (t.bind.apply(t, n));
          return r && c(o, r.prototype), o
        }(t, arguments, a(this).constructor)
      }

      return r.prototype = Object.create(t.prototype, {
        constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 }
      }),
      c(r, t)
    }, o(t)
  }

  function i() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}))
    } catch (t) {}
    return (i = function () { return !!t })()
  }

  function c(t, e) {
    return c = Object.setPrototypeOf
      ? Object.setPrototypeOf.bind()
      : function (t, e) { return t.__proto__ = e, t },
    c(t, e)
  }

  function a(t) {
    return a = Object.setPrototypeOf
      ? Object.getPrototypeOf.bind()
      : function (t) { return t.__proto__ || Object.getPrototypeOf(t) },
    a(t)
  }

  function u(e) {
    var r = function (e) {
      if ("object" != t(e) || !e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, "string");
        if ("object" != t(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.")
      }
      return String(e)
    }(e);
    return "symbol" == t(r) ? r : r + ""
  }

  var l = function (r) {

    function o() {
      var e, r, n;

      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
      }(this, o),

      e = function (e, r, n) {
        return r = a(r),
          function (e, r) {
            if (r && ("object" == t(r) || "function" == typeof r)) return r;
            if (void 0 !== r) throw new TypeError("Derived constructors may only return object or undefined");
            return function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t
            }(e)
          }(
            e,
            i()
              ? Reflect.construct(r, n || [], a(e).constructor)
              : r.apply(e, n)
          )
      }(this, o),

      r = e,
      (n = u(n = "currency")) in r
        ? Object.defineProperty(r, n, { value: "", enumerable: !0, configurable: !0, writable: !0 })
        : r[n] = "",

      e.currency = e.getAttribute("data-currency") || "",
      e
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: { value: t, writable: !0, configurable: !0 }
      });
      Object.defineProperty(t, "prototype", { writable: !1 });
      e && c(t, e)
    }(o, r),

    l = o,

    (f = [{

      key: "connectedCallback",
      value: function () {
        this.getActiveFilters()
      }

    }, {

      key: "getActiveFilters",
      value: function () {

        var t,
            r = this,
            n = new URLSearchParams(window.location.search),
            o = [],
            i = null === (t = document.querySelector("filters-drawer range-slider")) || void 0 === t
              ? void 0
              : t.getAttribute("max");

        Array.from(n.entries()).forEach(function (t) {
          var r = e(t, 2),
              n = r[0],
              c = r[1];

          if (
            ("filter.v.price.gte" !== n || "0" !== c) &&
            ("filter.v.price.lte" !== n || c !== i) &&
            "filter.v.m.custom.enable_variant" !== n &&
            n.startsWith("filter.")
          ) {
            var a = {};
            a[n] = c;
            o.push(a)
          }
        });

        0 !== o.length
          ? (
              this.classList.remove("hidden"),

              o.forEach(function (t) {

                var e = Object.keys(t)[0],
                    n = t[e],
                    o = n,
                    i = e.startsWith("filter.v.price.gte"),
                    c = e.startsWith("filter.v.price.lte");

                i && (o = "> ".concat(n, " ").concat(r.currency));
                c && (o = "< ".concat(n, " ").concat(r.currency));

                "filter.v.m.custom.enable_variant" !== e &&
                  r.addChip(n, e, o)

              }),

              this.querySelectorAll(".active-filters__chip").forEach(function (t) {
                t.addEventListener("click", r.handleChipClick)
              })

            )
          : this.classList.add("hidden")
      }

    }, {

      key: "addChip",
      value: function (t, e, r) {

        var n = this.querySelector("#chip-template");

        if (n) {
          var o = n.content.cloneNode(!0).querySelector(".active-filters__chip");

          if (o) {
            var i = o.querySelector(".active-filters__chip-label"),
                c = o.querySelector(".active-filters__chip-close");

            i && c && (
              i.textContent = (function(val){
            if (!window.collectionFilters) return val;

            let label = val;

            window.collectionFilters.forEach(function(filter){
                filter.values.forEach(function(v){
                if (v.value === val) {
                    label = v.label;
                }
                });
            });

            return label;

            })(r),
              o.setAttribute("data-filter-key", e),
              o.setAttribute("data-filter-value", t),
              this.insertAdjacentElement("afterbegin", o),
              o.addEventListener("click", this.handleChipClick)
            )
          }
        }

      }

    }, {

      key: "handleChipClick",
      value: function (t) {

        var r = t.target,
            n = r.getAttribute("data-filter-key"),
            o = r.getAttribute("data-filter-value"),
            i = Array.from(new URLSearchParams(window.location.search).entries()),

            c = i.findIndex(function (t) {
              var r = e(t, 2),
                  i = r[0],
                  c = r[1];
              return i === n && c === o
            });

        -1 !== c && i.splice(c, 1);

        var a = i.map(function (t) {
          var r = e(t, 2),
              n = r[0],
              o = r[1];
          return "".concat(encodeURIComponent(n), "=").concat(encodeURIComponent(o))
        }).join("&"),

        u = "".concat(window.location.pathname).concat(a ? "?" + a : "");

        window.history.replaceState({}, "", u),
        window.location.reload()

      }

    }]) && n(l.prototype, f),

    Object.defineProperty(l, "prototype", { writable: !1 }),
    l;

    var l, f

  }(o(HTMLElement));

  customElements.define("active-filters", l)

}();